import React from 'react';
import PerformanceWidget from './PerformanceWidget';

const PerformanceWidgetBasic = () => (
  <PerformanceWidget className="masonry-item w-[410px] h-[237px] rounded-lg flex flex-col" />
);

export default PerformanceWidgetBasic;
